import { US_STATE_CODES } from '../constants.js';
export const isValidUsState = (state) => US_STATE_CODES.has(state.trim().toUpperCase());
